import React , {useState} from "react";
import { useNavigate } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import '../css/Login.css';
import axios from 'axios';
import ip from '../ipserver';
//img
import loginbg from '../img/login-bg.png';
import ilusiontop from '../img/top-illustration.png';
import ilusionbot from '../img/bottom-illustration.png';
import { useLogin } from '../component/LoginContext';
function LoginPage() {
    
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('Username or Password is invalid');
    const [invalidUP , setInvalidUP ] = useState(true);
    const { login } = useLogin();

    const LoginFunction = async () => {
        try {
            const response = await axios.get(`https://${ip}/api/users`, {
                params: {
                    user: username,
                    pwd: password
                }
            });
            console.log(response.data.passcode)
            if(response.data.success == true){
                login( {name: username},{pass: password} ,{passCode: response.data.passcode});
                navigate(`/worklist/${response.data.passcode}`);
            }
            else{
                setInvalidUP(false);
            }
            
            
        } catch (error) {
            console.error("Login error:", error);
            setError('An error occurred during login');
            setInvalidUP(false);
        }
    }

    return (
        <div className="gradient_background" style={{ overflow: "hidden" }}>
            <img className="bgimg"src={loginbg} alt="loginbg"/>
            <img className="bg-ilusionT" src={ilusiontop} alt="ilusionT"/>
            <img className="bg-ilusionB" src={ilusionbot} alt="ilusionB"/>
            <div className="mlogin ">

                <Card className='cardbackground'>
                    <Card.Body >
                    <h3 className="cwel">Welcome to</h3>
                    <h1 className="cmed">MEDSMART</h1>
                    <p className="cmob mb-3">Mobile Bus Tele Medicine</p>
                        <p> Username</p>
                        <Form.Control placeholder='Enter your username'id='username'onChange={(e) => setUsername(e.target.value)} onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            LoginFunction();
                                        }
                                    }}></Form.Control>
                        <br />
                        <p> Password</p>
                        <Form.Control placeholder='Enter your password' type='password' id='password' onChange={(e) => setPassword(e.target.value)} onKeyPress={(e) => {
                                        if (e.key === 'Enter') {
                                            LoginFunction();
                                        }
                                    }}></Form.Control>
                        
                    <Button className='butsign mt-3'   onClick={LoginFunction} > 
                        <svg className="svgicon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M11 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4H11M3 12H14M14 12L11 15M14 12L11 9" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
                        Sing in
                    </Button>

                    <p  className={`invaliduser ${!invalidUP ? 'visible' : 'hidden'}`}>{error}</p>

                    </Card.Body>
                </Card>
                
            </div>
        </div>
      );
    }
    
export default LoginPage;
